export class ManageUserTab {
    departmentID:number;
    disabled:boolean;
    removable:boolean;
    title:string;
    active:boolean;
    managerUserTab:boolean;
    assignUserTab:boolean;
    userId:number;
    operatingCountryId:number;
    closeUserManageTab:boolean;
  }


// WEBPACK FOOTER //
// ./src/app/customerservice/models/manage-user-tab-model.ts